/**
 * Componente que oculta todas las acciones de escritura (crear, editar, eliminar) 
 * en la sección de categorías de anuncios.
 * Solo permite operaciones de lectura (GET).
 */
export const HideCategoryWriteActions = () => {
  return (
    <style>
      {`
        /* Ocultar botones de crear nueva categoría */
        button[data-testid="create-category-button"],
        a[data-testid="create-category-button"],
        button[aria-label*="category"],
        a[aria-label*="category"],
        .MuiButton-root[href*="/announcements/categories/new"],
        .MuiButtonBase-root[href*="/announcements/categories/new"],
        
        /* Ocultar botones de editar categoría */
        button[data-testid="edit-category-button"],
        a[data-testid="edit-category-button"],
        button[aria-label*="edit"],
        button[title*="edit"],
        .MuiIconButton-root[aria-label*="edit"],
        
        /* Ocultar botones de eliminar categoría */
        button[data-testid="delete-category-button"],
        a[data-testid="delete-category-button"],
        button[aria-label*="delete"],
        button[title*="delete"],
        .MuiIconButton-root[aria-label*="delete"],
        
        /* Ocultar menús de acciones y opciones */
        .MuiMenu-root button[role="menuitem"]:not([data-action="view"]),
        .MuiPopover-root button[role="menuitem"]:not([data-action="view"]),
        
        /* Ocultar formularios de categorías */
        form[action*="/announcements/categories"],
        .category-form,
        
        /* Ocultar iconos de más acciones en listas de categorías */
        .MuiTableCell-root .MuiIconButton-root[aria-label*="more"],
        .MuiTableCell-root .MuiIconButton-root[title*="actions"],
        
        /* Ocultar botones flotantes de acción */
        .MuiFab-root,
        button[class*="fab"],
        button[class*="floating-action"] {
          display: none !important;
        }

        /* Deshabilitar acciones de escritura en categorías específicamente */
        [data-testid*="category"] button:not([data-action="view"]):not([data-action="read"]),
        [class*="category"] button:not([data-action="view"]):not([data-action="read"]),
        [id*="category"] button:not([data-action="view"]):not([data-action="read"]) {
          pointer-events: none !important;
          opacity: 0.3 !important;
          cursor: not-allowed !important;
        }

        /* Ocultar campos de entrada y formularios de edición */
        input[name*="category"],
        textarea[name*="category"],
        select[name*="category"],
        .category-input,
        .category-textarea,
        .category-select {
          display: none !important;
        }
      `}
    </style>
  );
};
